// export const orange = '#ebc214';
export const orange = '#fff';

// export const pink = '#d61eed';
export const pink = '#fff';

export const white = '#fff';
